export default __webpack_public_path__ + "images/logo-wordmark.a3f0e9081320424e1ff1779eea5d8a2f.png";